<script setup lang="ts">
  import { UiBaseIcon } from '@experience/core-base-icon-ui';

  import { useClickTracker } from '@/shared/lib/analytics/compat';

  const props = defineProps<{
    title: string;
    analyticsBase: Record<string, unknown>;
  }>();

  const emit = defineEmits<{
    changeCity: [];
  }>();

  const vCityChangeClick = useClickTracker('around:hero-page:city-change.click');
  const cityChangeParams = () => ({ ...props.analyticsBase });
</script>

<template>
  <div class="around-page-heading">
    <h1 class="around-page-heading__title">{{ title }}</h1>

    <button
      v-city-change-click="cityChangeParams"
      class="around-page-heading__change-city"
      type="button"
      @click="emit('changeCity')"
    >
      <UiBaseIcon
        class="around-page-heading__location-icon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        aria-hidden="true"
      >
        <path
          d="M8.00008 12.9001C9.35564 11.6556 10.3612 10.5251 11.0167 9.5084C11.6723 8.49174 12.0001 7.58896 12.0001 6.80007C12.0001 5.58896 11.614 4.59729 10.8417 3.82507C10.0695 3.05285 9.1223 2.66674 8.00008 2.66674C6.87786 2.66674 5.93064 3.05285 5.15841 3.82507C4.38619 4.59729 4.00008 5.58896 4.00008 6.80007C4.00008 7.58896 4.32786 8.49174 4.98341 9.5084C5.63897 10.5251 6.64453 11.6556 8.00008 12.9001ZM8.00008 14.2167C7.84453 14.2167 7.68897 14.189 7.53341 14.1334C7.37786 14.0779 7.23897 13.9945 7.11675 13.8834C6.39453 13.2167 5.75564 12.5667 5.20008 11.9334C4.64453 11.3001 4.18064 10.6862 3.80841 10.0917C3.43619 9.49729 3.15286 8.92507 2.95841 8.37507C2.76397 7.82507 2.66675 7.30007 2.66675 6.80007C2.66675 5.1334 3.20286 3.80563 4.27508 2.81674C5.3473 1.82785 6.58897 1.3334 8.00008 1.3334C9.41119 1.3334 10.6529 1.82785 11.7251 2.81674C12.7973 3.80563 13.3334 5.1334 13.3334 6.80007C13.3334 7.30007 13.2362 7.82507 13.0417 8.37507C12.8473 8.92507 12.564 9.49729 12.1917 10.0917C11.8195 10.6862 11.3556 11.3001 10.8001 11.9334C10.2445 12.5667 9.60564 13.2167 8.88341 13.8834C8.76119 13.9945 8.6223 14.0779 8.46675 14.1334C8.31119 14.189 8.15564 14.2167 8.00008 14.2167ZM8.00008 8.00007C8.36675 8.00007 8.68064 7.86952 8.94175 7.60841C9.20286 7.34729 9.33341 7.0334 9.33341 6.66674C9.33341 6.30007 9.20286 5.98618 8.94175 5.72507C8.68064 5.46396 8.36675 5.3334 8.00008 5.3334C7.63341 5.3334 7.31953 5.46396 7.05841 5.72507C6.7973 5.98618 6.66675 6.30007 6.66675 6.66674C6.66675 7.0334 6.7973 7.34729 7.05841 7.60841C7.31953 7.86952 7.63341 8.00007 8.00008 8.00007Z"
        />
      </UiBaseIcon>

      Сменить город
    </button>
  </div>
</template>

<style scoped lang="scss">
  .around-page-heading__title {
    color: var(--alias-color-text-default);

    @include base-1000-950-extra;

    @include tablet {
      @include base-700-500-extra;
    }
  }

  .around-page-heading__change-city {
    display: flex;
    gap: var(--alias-space-4, 4px);
    align-items: center;
    width: fit-content;
    padding: var(--alias-space-4, 4px) var(--alias-space-8, 8px);
    margin-top: var(--alias-space-16, 16px);
    font-family: inherit;
    color: var(--alias-color-text-default);
    cursor: pointer;
    background: var(--alias-color-background-subtler);
    border: 0;
    border-radius: var(--alias-radius-8, 8px);

    @include base-300-300-medium;

    &:hover {
      opacity: 0.8;
    }

    &:focus-visible {
      outline: 2px solid var(--alias-color-border-focused);
      outline-offset: 2px;
    }
  }

  .around-page-heading__location-icon {
    flex: none;
    fill: currentcolor;
  }
</style>
